export class CacheIndex {
  /**
   * Index of cache entries. Keep track which keys are in the cache, and provide
   * query methods.
   * @param {TimeAwareCache} cache - The cache to index
   */
  constructor(cache) {
    cache.subscribe(this);
  }

  /**
   * Handle the onSet notification of the cache
   * @private
   * @param {TimeAwareCache} cache - The cache to index
   * @param {number} timestamp - The timestamp of the operation
   * @param {CacheEntry} entry - The cache entry being updated
   * @param {string} keyToReplace - The cache key being replaced
   * @returns {void}
   */
  onSet(cache, timestamp, { key } = {}, keyToReplace) {
    if (keyToReplace) {
      this.del(keyToReplace);
    }
    if (key) {
      this.add(key);
    }
  }

  /**
   * Handle the onDel notification of the cache
   * @private
   * @param {TimeAwareCache} cache - The cache to index
   * @param {number} timestamp - The timestamp of the operation
   * @param {CacheEntry} entry - The cache entry being updated
   * @returns {void}
   */
  onDel(cache, timestamp, { key } = {}) {
    if (key) {
      this.del(key);
    }
  }

  /**
   * Add a cache key to the index
   * @abstract
   * @param {string} key - The key to add
   * @returns {void}
   */
  add(/* key */) { }

  /**
   * Remove a cache key from the index
   * @abstract
   * @param {string} key - The key to remove
   * @returns {void}
   */
  del(/* key */) { }

  /**
   * Query the cached keys fits certain query
   * @abstract
   * @param {Object} query - The query object
   * @returns {string[]} - The keys matches the query
   */
  keys(/* query */) {
    return [];
  }
}
